import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ThirdPartyPlatform } from '@app/client/settings/shared/modules/integrations/integrations.model';
import { IsSignupApp } from '@app/core/utilities/app.utilities';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiEndpoint, ApiRequestHeader } from '../../models/api.models';
import { getCurrentStage } from '../../utilities/url.utilities';
import { getCookieByKey, UtilitiesService } from '../utilities.service';

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
  impersonate = null;
  logoutMessage: string;
  sessionEndMessage: string;
  constructor(
    private translate: TranslateService,
    private utilitiesService: UtilitiesService,
  ) {
    this.impersonate = this.utilitiesService.toImpersonate();
    this.translate.get('common').subscribe((val) => {
      this.logoutMessage = val['logout-info'];
      this.sessionEndMessage = val['session-end'];
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.indexOf('/assets/i18n') !== -1 || req.url.indexOf('portal/session') !== -1) {
      // ignore translations
      return next.handle(req);
    }
    /* #region  auth cookie token */
    if (
      req.url.startsWith(environment.app.resources.dashboard) || // apollo
      req.url.indexOf('signup') !== -1 || // connect app
      req.url.indexOf('billed-usage-report') !== -1 || // billed-usage app
      (IsSignupApp() && req.url.indexOf(environment.app.resources.dashboard) !== -1) || // to perform userinfo request in account signup
      Object.values(ThirdPartyPlatform).some((platform) =>
        req.url.startsWith(`${ApiEndpoint.Auth}/${platform.toLowerCase()}`),
      ) // third party platform
    ) {
      const token = getCookieByKey(
        IsSignupApp() && req.url.indexOf('signup') !== -1 && req.url.indexOf('signup/syncing') === -1
          ? 'signup-xsrf'
          : 'xsrf',
      );
      if (token !== null && !req.headers.has(ApiRequestHeader.XSRF)) {
        req = req.clone({ headers: req.headers.set(ApiRequestHeader.XSRF, token) });
        if (this.impersonate) {
          req = req.clone({
            headers: req.headers.set(ApiRequestHeader.Impersonate, this.impersonate),
          });
        }
      }
    }
    /* #endregion */
    if (req.url.startsWith(environment.app.resources.dashboard)) {
      req = req.clone({
        url: environment.app.stages[getCurrentStage()].appBaseURL + req.url,
      });
    }

    /* #region  login redirection */
    return next.handle(req).pipe(
      tap((d: any) => {
        if (d.body && d.headers) {
          d.body.headers = d.headers;
        }
      }),
    );
    /* #endregion */
  }
}
